import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import './index.sass';

const BuyModalItem = ({
	className,
	orderItem,
	quantity,
	itemsCount,
	groupedTotal,
	intl,
}) => {
	const { formatMessage } = intl;
	const messages = defineMessages({
		photosTitle: {
			id: 'buyModal.photosTitle',
			defaultMessage: 'Fotos',
		},
		photos: {
			id: 'buyModal.photos',
			defaultMessage: '{itemsQuantity, plural, one {1 foto} other {# fotos}}',
		},
		videosTitle: {
			id: 'buyModal.videosTitle',
			defaultMessage: 'Videos',
		},
		videos: {
			id: 'buyModal.videos',
			defaultMessage: '{itemsQuantity, plural, one {1 video} other {# videos}}',
		},
		photosVideosTitle: {
			id: 'buyModal.photosVideosTitle',
			defaultMessage: 'Fotos + Videos',
		},
		photosVideos: {
			id: 'buyModal.photosVideos',
			defaultMessage: '{itemsQuantity, plural, one {1 item} other {# items}}',
		},
		fixedProductQuantity: {
			id: 'buyModal.fixedProductQuantity',
			defaultMessage: '{quantity}x {productName}',
		},
		total: {
			id: 'buyModal.table.total',
			defaultMessage: 'Total',
		},
	});
	const isVideo = orderItem.product_type.is_video;
	const isPhoto = orderItem.product_type.is_photo;
	const isPhotoAndVideo = isVideo && isPhoto;
	const isFixedProduct = !isPhoto && !isVideo;
	const { product_type: productType = {} } = orderItem;
	const productLabel = productType.name || productType.description || '';
	const associatedItemsCount = itemsCount ?? orderItem.items.length;
	const lineQuantity = quantity ?? 1;
	const lineTotal = groupedTotal ?? orderItem.total;

	const getDescription = () => {
		if (isFixedProduct) {
			if (lineQuantity > 1) {
				return formatMessage(messages.fixedProductQuantity, {
					quantity: lineQuantity,
					productName: productLabel,
				});
			}

			return productLabel;
		}

		if (associatedItemsCount > 0) {
			if (isPhotoAndVideo) {
				return formatMessage(messages.photosVideos, { itemsQuantity: associatedItemsCount });
			}

			if (isPhoto) {
				return formatMessage(messages.photos, { itemsQuantity: associatedItemsCount });
			}

			return formatMessage(messages.videos, { itemsQuantity: associatedItemsCount });
		}

		return '0';
	};

	return (
		<div className={`BuyModal__table ${className}`}>
			<div className="BuyModal__table__item BuyModal__table__item--digital">
				<div className="BuyModal__table__item__title">
					{
						isFixedProduct ? productLabel :
						isPhotoAndVideo ? formatMessage(messages.photosVideosTitle) :
						isPhoto ? formatMessage(messages.photosTitle) : formatMessage(messages.videosTitle)}
				</div>
				<div className="BuyModal__table__item__description">
					{getDescription()}
				</div>
			</div>
			<div className="BuyModal__table__item BuyModal__table__item--price">
				<div className="BuyModal__table__item__title">
					{formatMessage(messages.total)}
				</div>
				<div className="BuyModal__table__item__description">
					{`R$ ${lineTotal || '0'}`}
				</div>
			</div>
		</div>
	);
};

BuyModalItem.propTypes = {
	className: PropTypes.string,
	orderItem: PropTypes.object.isRequired,
	quantity: PropTypes.number,
	itemsCount: PropTypes.number,
	groupedTotal: PropTypes.number,
	intl: PropTypes.object.isRequired,
};

BuyModalItem.defaultProps = {
	className: '',
	quantity: 1,
	itemsCount: null,
	groupedTotal: null,
};

export default injectIntl(BuyModalItem);
